<template>
  <div class="space" :class="space"></div>
</template>

<script>

export default {
  name: 'starFooter',
  props: {
    size: {
      type: String,
      default: 'sm'
    }
  },
  data () {
    return {
      availableSizes: ['xs', 'sm', 'md', 'lg']
    }
  },
  components: {},
  computed: {
    space () {
      if (this.availableSizes.includes(this.size)) {
        return this.size
      } else {
        return 'sm'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.space{
  &.xs{
    padding-bottom: 1.75rem;
  }
  &.sm{
    padding-bottom: 3.5rem;
  }
  &.md{
    padding-bottom: 7rem;
  }
  &.lg{
    padding-bottom: 14rem;
  }
}
</style>
